import { useTranslation } from 'react-i18next';
import { LoaderProps } from './types';

export const Loader = ({ classNames }: LoaderProps) => {
    const { t } = useTranslation();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 96 96"
            data-testid="loader"
            className={`w-[96px] h-auto ${classNames}`}
            role="img"
            aria-label={t('Generic.Loading')}
        >
            <circle cx="48" cy="48" r="46.5" fill="none" stroke="rgb(235 235 240)" strokeWidth="3" />
            <path
                className="origin-center stroke-primary animate-loaderCircle"
                d="M65.79,5.05h0c-2.46-1.02-5.05-1.84-7.74-2.44C32.99-2.94,8.16,12.88,2.61,37.94c-5.55,25.07,10.27,49.89,35.33,55.45,25.07,5.55,49.89-10.27,55.45-35.33,3.36-15.18-1.11-30.28-10.74-41.05"
                fill="none"
                strokeDasharray="272"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
            />
        </svg>
    );
};
